<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres
        :titulo="tituloCard"
        :botoes="botoesHeader"
        voltar
        breakpoint="xl"
      />
    </template>
    <div class="dadosGeraisUsuario" v-if="usuario">
      <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold">Dados Pessoais</h6>
      <b-row class="text-left m-3">
        <b-col cols="12" lg="6" xl="4">
          <span>Nome: </span>
          <span>{{ capitalize(usuario.NOME) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>CPF: </span>
          <span>{{ formatarCPF(usuario.CPF) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Email: </span>
          <span class="text-lowercase">{{ usuario.EMAIL }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>RG: </span>
          <span>{{ usuario.RG }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Situação: </span>
          <span>{{ formatarInativo(usuario.INATIVO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Início da Vigência: </span>
          <span>{{ formatData(usuario.DATA_INICIO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Número da OAB: </span>
          <span>{{ usuario.OAB }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Protocolo de criação: </span>
          <span>{{ usuario.NR_PROTOCOLO }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Telefone: </span>
          <span>
            <a :href="linkParaZap">{{ usuario.NM_TELEFONE }}</a>
          </span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Sexo: </span>
          <span>{{ formatarSexo(usuario.ID_CRP_SEXO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Último acesso: </span>
          <span>{{ formatData(usuario.DT_ULTIMOACESSO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Autoriza comunicações por email, SMS, etc? </span>
          <span>{{ simOuNao(usuario.FL_COMUNICA_TELEFONE) }}</span>
        </b-col>
        <b-col cols="12">
          <span>Última alteração: </span>
          <span
            >{{ formatData(usuario.DATA_ULT_ALTERACAO) }} por
            {{ capitalize(usuario.USUARIO_ULT_ALTERACAO) }}</span
          >
        </b-col>
      </b-row>
      <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold mt-4">
        Dados de Endereço
      </h6>
      <b-row class="text-left m-3">
        <b-col cols="12" lg="6" xl="4">
          <span>Bairro: </span>
          <span>{{ capitalize(usuario.NM_BAIRRO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>CEP: </span>
          <span>{{ formatarCEP(usuario.NM_CEP) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Complemento: </span>
          <span v-if="usuario.NM_COMPLEMENTO">{{
            capitalize(usuario.NM_COMPLEMENTO)
          }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Logradouro: </span>
          <span>{{ capitalize(usuario.NM_LOGRADOURO) }}</span>
        </b-col>
        <b-col cols="12" lg="6" xl="4">
          <span>Número: </span>
          <span v-if="usuario.NU_NUMERO">{{
            removeZeroEsquerda(usuario.NU_NUMERO)
          }}</span>
        </b-col>
      </b-row>
      <h6 class="mt-3 ml-2 mb-0 text-left font-weight-bold mt-4">
        UGs e Perfis
      </h6>
      <b-row class="text-left m-3">
        <b-col
          v-if="
            !ugsPerfisArray ||
            (ugsPerfisArray[0].ug &&
              ugsPerfisArray[0]?.perfis.length === 0 &&
              ugsPerfisArray[0]?.ug.length === 0)
          "
        >
          <div class="alert alert-info" role="alert">
            Não há cadastro de permissões para este usuário.
          </div>
        </b-col>
        <b-col v-else-if="ugsPerfisArray">
          <table class="table table-bordered table-striped">
            <tbody>
              <tr v-for="(usuarioPerfil, index) in ugsPerfisArray" :key="index">
                <th v-if="usuarioPerfil.ug" class="w-50">
                  {{ usuarioPerfil.ug }}
                </th>
                <td v-if="usuarioPerfil.ug">
                  <span
                    v-for="(perfis, index) in usuarioPerfil.perfis"
                    :key="index"
                    class="font-weight-normal"
                  >
                    {{ perfis }}<br />
                  </span>
                </td>
                <th
                  v-else-if="
                    usuarioPerfil.perfis[0] != undefined &&
                    usuarioPerfil.perfis[0].length > 0
                  "
                  colspan="2"
                  class="text-uppercase"
                >
                  {{ usuarioPerfil.perfis[0] }}
                </th>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
    <div class="dadosGeraisUsuario" v-else>
      <h6>Dados não encontrados</h6>
    </div>
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import usuarioService from "@/services/administracao/usuarioService";
import { store } from "@/store";
import { ListaPermissoes } from "@/types/administracao/usuarios/lista-permissoes";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import { UsuarioPerfil } from "@/types/administracao/usuarios/usuario-perfil";
import { BotaoSagres } from "@/types/botao-sagres";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";

const CompProps = Vue.extend({
  name: "DetalhesUsuario",
  components: { HeaderSagres },
  props: {
    idUsuario: {
      type: String,
      required: true,
    },
  },
});

@Component
export default class DetalhesUsuario extends mixins(UtilsTS, CompProps) {
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "pencil",
      texto: "Editar",
      url: `/seguranca-administracao/usuarios/${this.idUsuario}/editar`,
    },
  ];
  usuario: Usuario | null = null;
  ugsPerfisArray: ListaPermissoes[] | null = null;

  linkParaZap = "";

  async mounted() {
    try {
      store.blockScreen = true;
      this.usuario = await usuarioService.getUsuarioById(this.idUsuario);

      if (this.usuario.NM_TELEFONE) {
        this.linkParaZap = `https://wa.me/55${
          this.usuario.NM_TELEFONE.length == 9 ? "79" : ""
        }${this.apenasNumeros(this.usuario.NM_TELEFONE)}`;
      }
    } catch (e: any) {
      this.tratarError(e);
      console.error(e);
    } finally {
      store.blockScreen = false;
    }

    if (this.usuario?.perfis != null && this.usuario?.perfis?.length > 0) {
      this.ugsPerfisArray = this.listaUgPerfil(this.usuario.perfis);
    } else this.ugsPerfisArray = null;
  }

  listaUgPerfil(perfis: UsuarioPerfil[]): ListaPermissoes[] {
    const ugsUnicas = new Set(perfis.map((p) => p.ug));
    const ugsUnicasArray = [...ugsUnicas].map((u) => new ListaPermissoes(u));
    perfis.forEach((p) => {
      ugsUnicasArray
        .find((u) => {
          if (u.ug === "") u.ug = undefined;
          return u.ug == p.ug;
        })
        ?.perfis.push(p.perfil.Descricao);
    });
    ugsUnicasArray.forEach((ele) => {
      ele.perfis.join(", ");
    });
    return ugsUnicasArray;
  }

  get tituloCard(): string {
    return this.usuario
      ? `Usuário ${this.usuario.NOME}`
      : "Falha ao obter usuário";
  }
}
</script>

<style scoped>
div span:first-of-type {
  font-weight: bold;
}
</style>